<div class="heading py-5">
  <h1 class="bold font-curve-large">Collapse</h1>
  <app-dependency-link></app-dependency-link>
</div>

<section class="mb-0 pb-5">
  <app-ngb-collapse-demo></app-ngb-collapse-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplate"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>
